import { BaseCommon } from "./base-common.abstract";
export class BaseStoreDevice extends BaseCommon {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "_userAgent", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_navigator", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isTablet", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                return (this._userAgent.search(/ipad/i) > -1 ||
                    (this._userAgent.search(/android/i) > -1 && this._userAgent.search(/mobile/i) <= -1) ||
                    (this._userAgent.match(/Mac/) && !!this._navigator?.maxTouchPoints && this._navigator?.maxTouchPoints > 2) // phaser- introduced this check due to iPadOS, as Safari there now mimick's desktop..
                );
            }
        });
        Object.defineProperty(this, "isMobile", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                return (this._userAgent.search(/iphone/i) > -1 ||
                    (this._userAgent.search(/android/i) > -1 && this._userAgent.search(/mobile/i) > -1));
            }
        });
    }
}
//# sourceMappingURL=base-device.abstract.js.map